import { Disclosure } from "@heroui/react";

import { useTranslations } from "@/src/i18n/i18n";

/**
 * Les deux règles de la modération, écrites **une fois** pour tout l'écran.
 *
 * Elles vivaient sous les boutons de chaque carte. Sur une file de trente
 * signalements, c'est trente fois le même avertissement — et un avertissement
 * répété trente fois ne se lit plus. Ici il reste atteignable, à côté du geste
 * qu'il explique, sans être dans le chemin de celui qui le connaît déjà.
 *
 * Replié par défaut : le modérateur habituel ne l'ouvre jamais, le nouveau
 * l'ouvre une fois.
 */
export function ReportsHelp() {
  const t = useTranslations("reports");

  return (
    <Disclosure className="rounded-lg border border-separator px-4">
      {/* `level={2}` : la coque titre déjà la page en `h1` et les cartes sont
          des `h2`. Laissée à son défaut (`h3`), l'aide ouvrirait un niveau que
          rien ne referme, juste avant des titres de rang supérieur. */}
      <Disclosure.Heading level={2}>
        {/* `flex` bat le `inline-block` de `.disclosure__trigger` — la classe
            de composant est dans `@layer components`, l'utilitaire plus loin
            dans l'ordre (cf. § « Qui gagne » du CLAUDE.md). */}
        <Disclosure.Trigger className="flex w-full items-center justify-between gap-2 py-3 text-sm text-muted">
          {t("help-open")}
          <Disclosure.Indicator />
        </Disclosure.Trigger>
      </Disclosure.Heading>

      <Disclosure.Content>
        <Disclosure.Body className="flex flex-col gap-3 px-0 pb-4 text-sm text-pretty text-muted">
          <p>
            <span className="font-medium text-foreground">{t("verdict")}</span>{" "}
            — {t("verdict-note")} {t("no-reopen")}
          </p>

          <p>
            <span className="font-medium text-foreground">{t("sanction")}</span>{" "}
            — {t("sanction-note")}
          </p>
        </Disclosure.Body>
      </Disclosure.Content>
    </Disclosure>
  );
}
